import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useLazyRestQuery from "@/remoteState/useLazyRestQuery";
import { ContentPromotionForm } from "@/types/models/ContentPromotionForm.interface";
import { District } from "@/types/models/District.interface";
import { School } from "@/types/models";
import { GradeRange, SubjectProductSlug } from "../../types";

interface ParamsToUpdateOrCreateContentPromotionForm {
  form_id?: ContentPromotionForm["id"] | undefined;
  grade_minimum?: GradeRange["min_grade"];
  grade_maximum?: GradeRange["max_grade"];
  product_slug?: SubjectProductSlug | undefined;
  district_id?: District["unique_id"] | undefined;
  school_id?: School["unique_id"] | undefined;
  is_published?: boolean;
}

const useLazyContentPromotionFormPost = (
  data: ParamsToUpdateOrCreateContentPromotionForm,
) => {
  const requestPath = data?.form_id
    ? `${MONOLITH_ORIGIN}/api/v3/platform-alignment-form/${data.form_id}/`
    : `${MONOLITH_ORIGIN}/api/v3/platform-alignment-form/`;

  const requestUrl = new Request(requestPath, {
    method: "POST",
    body: JSON.stringify(data),
    headers: { "Content-Type": "application/json" },
  });

  return useLazyRestQuery(requestUrl);
};

export default useLazyContentPromotionFormPost;
